import {
  Getters,
  Mutations,
  Actions,
  Module,
  createMapper,
} from 'vuex-smart-module';

class SidebarState {
  isOpened = false;
}

class SidebarGetters extends Getters<SidebarState> {
  get sidebarState() {
    return this.state.isOpened;
  }
}

class SidebarMutations extends Mutations<SidebarState> {
  toggle(payload: boolean) {
    this.state.isOpened = payload;
  }
}

class SidebarActions extends Actions<
  SidebarState,
  SidebarGetters,
  SidebarMutations,
  SidebarActions
> {
}

// Экспорт модуля
export const SidebarModule = new Module({
  state: SidebarState,
  getters: SidebarGetters,
  mutations: SidebarMutations,
  actions: SidebarActions,
});

export const SidebarModuleMapper = createMapper(SidebarModule);
